import { first } from 'rxjs/operators';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ReservationLedgerService } from '../reservation-ledger/reservation-ledger.service';
import { ReservationLedger } from '../reservation-ledger/reservation-ledger';
import { ReservationLedgerComponent } from '../reservation-ledger/reservation-ledger/reservation-ledger.component';
import * as moment from 'moment';

@Component({
	selector: 'app-reservation-ledger-list-summary-old',
	templateUrl: './reservation-ledger-list-summary.component-old.html',
	styleUrls: ['./reservation-ledger-list-summary.component-old.css'],
	standalone: false,
	// make column heading sticky
	styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`]
})
export class ReservationLedgerListSummaryComponentOld implements OnInit {
    payToDetails: any;
	showFilter = true;
	showPagination = true;
	displayClose = true;
	reservationId: any;
	title: any;
	isSearching = false;
	grandTotalAmount: any;
	constructor(
		private reservationLedgerService: ReservationLedgerService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
		@Inject(MAT_DIALOG_DATA) data: any) 
		{
		this.title = data?.title;
		this.showFilter = data?.showFilter;
		this.showPagination = data?.showPagination;
		this.displayClose = data?.displayClose;
		this.reservationId = data?.reservationId;
		this.statuses = reservationLedgerService.statuses;
		this.payToDetails = reservationLedgerService.payToDetails;
	}



	// data
	reservationLedgers: any;
	reservationLedger: ReservationLedger;

	ledgerGrandTotalByReservation = new Map();
	ledgerNetTotalByReservation = new Map();

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'propertyCode', header: 'Property', width: 'auto', sortingField: 'reservationVO.shortTermRentalVO.propertyCode' },
		{ field: 'guestLastName', header: 'Name', width: 'auto', sortingField: 'reservationVO.guestProfileVO.lastName' },
		{ field: 'orderId', header: 'Order #', width: 'auto', sortingField: 'reservationVO.orderVO.orderId' },
		{ field: 'reservationId', header: 'Res #', width: 'auto', sortingField: 'reservationVO.reservationId' },
		// { field: 'status', header: 'Status', width: 'auto' },
		{ field: 'checkInDateTime', header: 'In', width: 'auto', sortingField: 'reservationVO.checkInDateTime' },
		{ field: 'checkOutDateTime', header: 'Out', width: 'auto', sortingField: 'reservationVO.checkOutDateTime' },
		{ field: 'orderProductName', header: 'Title', width: 'auto', sortingField: 'orderProductVO.name' },
		{ field: 'payFromOrderProductName', header: 'Pay From Order Prod', width: 'auto', sortingField: 'payFromOrderProductVO.name' },
		{ field: 'payFrom', header: 'PayFrom', width: 'auto', sortingField: 'payFrom' },
		{ field: 'payTo', header: 'PayTo', width: 'auto', sortingField: 'payTo' },
		{ field: 'quantity', header: 'Qty', width: 'auto', sortingField: 'quantity' },
		{ field: 'listPrice', header: 'Price', width: 'auto', sortingField: 'listPrice' },
		{ field: 'listPriceAdjustmentPercent', header: 'LPA %', width: 'auto', sortingField: 'listPriceAdjustmentPercent' },
		{ field: 'listPriceAdjustmentAmount', header: 'LPA $', width: 'auto', sortingField: 'listPriceAdjustmentAmount' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			// this.multiSortMeta.push({ field: 'orderProductVO.orderProductId', order: 1 });
			this.multiSortMeta.push({ field: 'reservationVO.checkInDateTime', order: 1 }, { field: 'reservationVO.reservationId', order: 1 }, { field: 'orderProductVO.orderProductId', order: 1 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.reservationLedgerId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-reservationLedger-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			if (event.filters?.['reservationVO.checkInDateTime']) {
				event.filters['reservationVO.checkInDateTime'].value = moment(event.filters?.['reservationVO.checkInDateTime'].value).format('MM/DD/YYYY');
			}

			if (event.filters?.['reservationVO.checkOutDateTime']) {
				event.filters['reservationVO.checkOutDateTime'].value = moment(event.filters?.['reservationVO.checkOutDateTime'].value).format('MM/DD/YYYY');
			}

			if (this.reservationId) {
				// show only activities that are assigned to this activityProviderId
				let reservationIdFilter = { 'reservationVO.reservationId': { 'value': this.reservationId, 'matchMode': 'in' } };
				Object.assign(event.filters, reservationIdFilter);
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.reservationLedgerService.findSummaryByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.reservationLedgers = res.data.reservationLedgers;
						let grandTotalAmount = 0;
						this.ledgerGrandTotalByReservation = new Map();
						this.ledgerNetTotalByReservation = new Map();
						this.reservationLedgers.forEach(reservationLedger => {
							let grandTotalPrice = (reservationLedger?.quantity * reservationLedger?.listPrice);
							if(this.ledgerGrandTotalByReservation.get(reservationLedger.reservationId))
							{
								grandTotalPrice = grandTotalPrice + this.ledgerGrandTotalByReservation.get(reservationLedger.reservationId);
							}
							this.ledgerGrandTotalByReservation.set(reservationLedger.reservationId, grandTotalPrice);

							//Owner Income + KBM Income
							if(reservationLedger.orderProductId == 105 || reservationLedger.orderProductId == 106)
							{
								let netTotalPrice = (reservationLedger?.quantity * reservationLedger?.listPrice);
								if(this.ledgerNetTotalByReservation.get(reservationLedger.reservationId))
								{
									netTotalPrice = netTotalPrice + this.ledgerNetTotalByReservation.get(reservationLedger.reservationId);
								}
								this.ledgerNetTotalByReservation.set(reservationLedger.reservationId, netTotalPrice);
							}
						});
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.reservationLedgers = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(reservationLedger: ReservationLedger) {
		try {
			this.formLoading = true;
			this.reservationLedgerService.update(reservationLedger)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.reservationLedgers.map((reservationLedger, i) => {
							if (reservationLedger.reservationLedgerId === res.data.reservationLedger.reservationLedgerId) {
								this.reservationLedgers[i] = res.data.reservationLedger;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(reservationLedger: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(reservationLedger));

			this.formLoading = true;
			this.reservationLedgerService.delete(reservationLedger.reservationLedgerId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.reservationLedgers.splice(this.reservationLedgers.indexOf(reservationLedger), 1);
						this.recordTotal = this.reservationLedgers.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "40vw";

		// pass data, ie reservationId: this.reservationId, to load reservation Agent APIs data
		let reservationLedger = {
			reservationId : this.reservationId

		}
		dialogConfig.data = {
			title: 'Add ReservationLedger',
			reservationLedger: reservationLedger,
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationLedgerComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addReservationLedgerCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(reservationLedger: ReservationLedger) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;
		dialogConfig.maxWidth = "60vw";
			dialogConfig.width = "30vw";

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			reservationLedger: reservationLedger,
			title: 'Edit ReservationLedger'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ReservationLedgerComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateReservationLedgerCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteReservationLedgerCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addReservationLedgerCB(reservationLedger: ReservationLedger) {
		console.log('Adding ReservationLedger: ' + JSON.stringify(reservationLedger));
		// RefreshTable to recalculate ledger amount
		this.refreshTable();
		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Added', life: 3000 });
	}

	updateReservationLedgerCB(reservationLedger: ReservationLedger) {
		console.log('Updating ReservationLedger: ' + JSON.stringify(reservationLedger));
	/*	let itemIndex = this.reservationLedgers.findIndex((item: any) => item.reservationLedgerId === reservationLedger.reservationLedgerId);
		this.reservationLedgers[itemIndex] = reservationLedger;

		// no idea what this is but it is required to update the array
		this.reservationLedgers = [...this.reservationLedgers];*/
		// RefreshTable to recalculate ledger amount
		this.refreshTable();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Updated', life: 3000 });
	}

	deleteReservationLedgerCB(reservationLedger: ReservationLedger) {
		console.log('Removing ReservationLedger: ' + reservationLedger);
		/*this.reservationLedgers.splice(this.reservationLedgers.indexOf(reservationLedger), 1);
		this.recordTotal = this.reservationLedgers.length;

		// no idea what this is but it is required to update the array
		this.reservationLedgers = [...this.reservationLedgers];*/
		// RefreshTable to recalculate ledger amount
		this.refreshTable();

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ReservationLedger ' + reservationLedger.reservationLedgerId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.reservationLedgers ? this.first === (this.reservationLedgers.length - this.rows) : true; }
	isFirstPage(): boolean { return this.reservationLedgers ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(reservationLedger: any) {
		if (reservationLedger?.status) {
			const status = this.statuses.find((e: any) => e.value == reservationLedger.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	getPayToName(reservationLedger: any) {
		if (reservationLedger?.payTo) {
			const status = this.payToDetails.find((e: any) => e.value == reservationLedger.payTo);
			return status.name;
		}
		else {
			return '';
		}
	}
	getPayFromName(reservationLedger: any) {
		if (reservationLedger?.payFrom) {
			const status = this.payToDetails.find((e: any) => e.value == reservationLedger.payFrom);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}

	generateLedgers() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.generateLedgers(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	toggleLedgerItemsLock(reservationLedger: any) {
		this.isSearching = true;
		try {
			this.reservationLedgerService.toggleLedgerItemsLock(reservationLedger?.reservationLedgerId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	lockLedger() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.lockLedger(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	unlockLedger() {
		this.isSearching = true;
		try {
			this.reservationLedgerService.unlockLedger(this.reservationId)
				.subscribe(
					res => {
						this.isSearching = false;
						console.log('findAllReservations: ' + JSON.stringify(res));
						this.loadLazy(this.lazyLoadEvent);
						// this.reservations = res.data.reservations;
						// return this.reservations;
					},
					err => {
						this.isSearching = false;
						console.log('Feature-Update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });
		} catch (error) {
			this.isSearching = false;
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	total(reservationLedger: any){
		return (reservationLedger?.quantity * reservationLedger?.listPrice);
	}

	getReservationLedgerTitle(reservationLedger: any){
		let orderProductName = reservationLedger?.orderProductName;
		let isTax = reservationLedger?.ledgerItemType === 2 || false;
		if(isTax && reservationLedger.title){
			return  orderProductName + ':' + reservationLedger?.title  + ' ('+reservationLedger?.opsNotes+'%)';
		}
		return orderProductName;
	}

	grandTotal(){
		this.grandTotalAmount = 0;
		this.reservationLedgers.forEach(reservationLedger => {
			this.grandTotalAmount = this.grandTotalAmount + (reservationLedger?.quantity * reservationLedger?.listPrice);
		});
		return this.grandTotalAmount;
	}

	grandTotalFromLedgerMap(reservationId){
		console.log(this.ledgerGrandTotalByReservation.get(reservationId))
		return this.ledgerGrandTotalByReservation.get(reservationId);
	}

	netTotalFromLedgerMap(reservationId)
	{
		console.log(this.ledgerNetTotalByReservation.get(reservationId))
		return this.ledgerNetTotalByReservation.get(reservationId);
	}

	refreshTable(){this.loadLazy(this.lazyLoadEvent);}

}
